import script from "./YTableDeleteButton.vue?vue&type=script&setup=true&lang=js"
export * from "./YTableDeleteButton.vue?vue&type=script&setup=true&lang=js"

import "./YTableDeleteButton.vue?vue&type=style&index=0&id=dc1a745e&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/线上短信平台/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc1a745e"]])

export default __exports__